<template>
  <ValidationObserver ref="validate">
    <div class="check-job">
      <h3 class="title1" style="height:150px;">
        {{ $t('advanced.employment.info') }}
        <div class="labelInexchangable lineAdjust pr-4 pb-2" style="border-bottom: 1px solid #E6EAF0;">{{ $t('advanced.employment.proofOfIncomeDocuments') }}</div>
      </h3>
      <div class="input-form form" :class="{ disabled: disable }">
        <div class="form-group">
          <!-- <q-field
            :error="$v.form.employStatus.$error"
            :error-label="getErrorLabel($v.form.employStatus, 'employStatus')"
          >
            <q-select
              v-model="form.employStatus"
              class="quasar-qselect glay-bg"
              :class="{'invalid-class': $v.form.employStatus.$error}"
              :float-label="$t('advanced.employment.employStatus')"
              @input="_employmentStatusSelect"
              :options="workStatus"
            ></q-select>
          </q-field>-->

          <SelectComponent
            ref="employStatus"
            :model.sync="form.employStatus"
            :label="$t('advanced.employment.employStatus')"
            :outlined="true"
            :rules="rules.employStatus"
            :readonly="disable"
            :value="form.employStatus"
            :items="workStatus"
          ></SelectComponent>
        </div>
        <div class="form-group">
          <!-- <q-field
            :error="$v.form.sourceIncome.$error"
            :error-label="getErrorLabel($v.form.sourceIncome, 'sourceIncome')"
          >
            <q-select
              v-model="form.sourceIncome"
              class="quasar-qselect glay-bg"
              :class="{'invalid-class': $v.form.sourceIncome.$error}"
              :float-label="$t('advanced.employment.sourceIncome')"
              @input="_sourceIncomeSelect"
              :options="sourceIncome"
            ></q-select>
          </q-field>-->

          <SelectComponent
            ref="sourceIncome"
            :model.sync="form.sourceIncome"
            :label="$t('advanced.employment.sourceIncome')"
            :outlined="true"
            :rules="rules.sourceIncome"
            :readonly="disable"
            :value="form.sourceIncome"
            :items="sourceIncome"
          ></SelectComponent>

          <!-- <q-field
            v-if="form.otherSourceIncome"
            :error="$v.form.sourceIncomeName.$error"
            :error-label="getErrorLabel($v.form.sourceIncomeName, 'sourceIncomeName')"
          >
            <q-input
              v-model="form.sourceIncomeName"
              class="quasar-qfield glay-bg"
              @blur="$v.form.sourceIncomeName.$touch"
              :class="{'invalid-class': $v.form.sourceIncomeName.$error}"
              :float-label="$t('advanced.employment.sourceIncomeName')"
            />
          </q-field>-->

          <TextFieldComponent
            v-if="form.sourceIncomeName"
            ref="sourceIncomeName"
            :model.sync="form.sourceIncomeName"
            :label="$t('advanced.employment.sourceIncomeName')"
            :outlined="true"
            :rules="rules.sourceIncomeName"
            :readonly="disable"
            :value="form.sourceIncomeName"
          ></TextFieldComponent>
        </div>
        <div class="form-group">
          <!-- <q-field
            :error="$v.form.industry.$error"
            :error-label="getErrorLabel($v.form.industry, 'industry')"
          >
            <q-select
              v-model="form.industry"
              class="quasar-qselect glay-bg"
              :class="{'invalid-class': $v.form.industry.$error}"
              :float-label="$t('advanced.employment.industry')"
              @input="_industrySelect"
              :options="industries"
            ></q-select>
          </q-field>-->

          <SelectComponent
            ref="industry"
            :model.sync="form.industry"
            :label="$t('advanced.employment.industry')"
            :outlined="true"
            :rules="rules.industry"
            :readonly="disable"
            :value="form.industry"
            :items="industries"
          ></SelectComponent>

          <!-- <q-field
            v-if="form.otherIndustry"
            :error="$v.form.industryName.$error"
            :error-label="getErrorLabel($v.form.industryName, 'industryName')"
          >
            <q-input
              v-model="form.industryName"
              class="quasar-qfield glay-bg"
              @blur="$v.form.industryName.$touch"
              :class="{'invalid-class': $v.form.industryName.$error}"
              :float-label="$t('advanced.employment.industryName')"
            />
          </q-field>-->

          <TextFieldComponent
            v-if="form.otherIndustry"
            ref="industryName"
            :model.sync="form.industryName"
            :label="$t('advanced.employment.industryName')"
            :outlined="true"
            :rules="rules.industryName"
            :readonly="disable"
            :value="form.industryName"
          ></TextFieldComponent>
        </div>
        <div class="form-group">
          <!-- <q-field
            class="quasar-qfield glay-bg"
            :error="$v.form.jobTitle.$error"
            :error-label="getErrorLabel($v.form.jobTitle, 'jobTitle')"
          >
            <q-input
              v-model="form.jobTitle"
              @blur="$v.form.jobTitle.$touch"
              :class="{'invalid-class': $v.form.jobTitle.$error}"
              :float-label="$t('advanced.employment.jobTitle')"
            />
          </q-field>-->
          <TextFieldComponent
            ref="jobTitle"
            :model.sync="form.jobTitle"
            :label="$t('advanced.employment.jobTitle')"
            :outlined="true"
            :rules="rules.jobTitle"
            :readonly="disable"
            :value="form.jobTitle"
          ></TextFieldComponent>
        </div>
        <div class="form-group">
          <!-- <q-field
            class="quasar-qfield glay-bg"
            :error="$v.form.companyName.$error"
            :error-label="getErrorLabel($v.form.companyName, 'companyName')"
          >
            <q-input
              v-model="form.companyName"
              @blur="$v.form.companyName.$touch"
              :class="{'invalid-class': $v.form.companyName.$error}"
              :float-label="$t('advanced.employment.companyName')"
            ></q-input>
          </q-field>-->

          <TextFieldComponent
            ref="companyName"
            :model.sync="form.companyName"
            :label="$t('advanced.employment.companyName')"
            :outlined="true"
            :rules="rules.companyName"
            :readonly="disable"
            :value="form.companyName"
          ></TextFieldComponent>
        </div>
        <div class="form-group">
          <!-- <q-field
            class="quasar-qfield glay-bg"
            :error="$v.form.employerBuilding.$error"
            :error-label="getErrorLabel($v.form.employerBuilding, 'employerStreet')"
          >
            <q-input
              v-model="form.employerBuilding"
              @blur="$v.form.employerBuilding.$touch"
              :class="{'invalid-class': $v.form.employerBuilding.$error}"
              :float-label="$t('advanced.employment.employerBuilding')"
            ></q-input>
          </q-field>-->

          <TextFieldComponent
            ref="employerBuilding"
            :model.sync="form.employerBuilding"
            :label="$t('advanced.employment.employerBuilding')"
            :outlined="true"
            :rules="rules.employerBuilding"
            :readonly="disable"
            :value="form.employerBuilding"
          ></TextFieldComponent>
        </div>
        <div class="form-group">
          <!-- <q-field
            class="quasar-qfield glay-bg"
            :error="$v.form.employerStreet.$error"
            :error-label="getErrorLabel($v.form.employerStreet, 'employerStreet')"
          >
            <q-input
              v-model="form.employerStreet"
              @blur="$v.form.employerStreet.$touch"
              :class="{'invalid-class': $v.form.employerStreet.$error}"
              :float-label="$t('advanced.employment.employerStreet')"
            ></q-input>
          </q-field>-->

          <TextFieldComponent
            ref="employerStreet"
            :model.sync="form.employerStreet"
            :label="$t('advanced.employment.employerStreet')"
            :outlined="true"
            :rules="rules.employerStreet"
            :readonly="disable"
            :value="form.employerStreet"
          ></TextFieldComponent>
        </div>
        <div class="form-group">
          <!-- <q-field
            class="quasar-qfield glay-bg"
            :error="$v.form.employerZipCode.$error"
            :error-label="getErrorLabel($v.form.employerZipCode, 'employerZipCode')"
          >
            <q-input
              v-model="form.employerZipCode"
              @blur="$v.form.employerZipCode.$touch"
              :class="{'invalid-class': $v.form.employerZipCode.$error}"
              :float-label="$t('advanced.employment.employerZipCode')"
            ></q-input>
          </q-field>-->

          <TextFieldComponent
            ref="employerZipCode"
            :model.sync="form.employerZipCode"
            :label="$t('advanced.employment.employerZipCode')"
            :outlined="true"
            :rules="rules.employerZipCode"
            :readonly="disable"
            :value="form.employerZipCode"
          ></TextFieldComponent>
        </div>
        <div class="form-group">
          <!-- <q-field
            class="quasar-qfield glay-bg"
            :error="$v.form.employerCity.$error"
            :error-label="getErrorLabel($v.form.employerCity, 'employerCity')"
          >
            <q-input
              v-model="form.employerCity"
              @blur="$v.form.employerCity.$touch"
              :class="{'invalid-class': $v.form.employerCity.$error}"
              :float-label="$t('advanced.employment.employerCity')"
            ></q-input>
          </q-field>-->

          <TextFieldComponent
            ref="employerCity"
            :model.sync="form.employerCity"
            :label="$t('advanced.employment.employerCity')"
            :outlined="true"
            :rules="rules.employerCity"
            :readonly="disable"
            :value="form.employerCity"
          ></TextFieldComponent>
        </div>
        <div class="form-group">
          <!-- <q-field
            class="quasar-qfield glay-bg"
            :error="$v.form.employerDistrict.$error"
            :error-label="getErrorLabel($v.form.employerDistrict, 'employerDistrict')"
          >
            <q-input
              v-model="form.employerDistrict"
              @blur="$v.form.employerDistrict.$touch"
              :class="{'invalid-class': $v.form.employerDistrict.$error}"
              :float-label="$t('advanced.employment.employerDistrict')"
            ></q-input>
          </q-field>-->

          <TextFieldComponent
            ref="employerDistrict"
            :model.sync="form.employerDistrict"
            :label="$t('advanced.employment.employerDistrict')"
            :outlined="true"
            :rules="rules.employerDistrict"
            :readonly="disable"
            :value="form.employerDistrict"
          ></TextFieldComponent>
        </div>
        <div class="form-group">
          <!-- <q-field
            class="quasar-qfield glay-bg"
            :error="$v.form.employerProvince.$error"
            :error-label="getErrorLabel($v.form.employerProvince, 'employerProvince')"
          >
            <q-input
              v-model="form.employerProvince"
              @blur="$v.form.employerProvince.$touch"
              :class="{'invalid-class': $v.form.employerProvince.$error}"
              :float-label="$t('advanced.employment.employerProvince')"
            ></q-input>
          </q-field>-->

          <TextFieldComponent
            ref="employerProvince"
            :model.sync="form.employerProvince"
            :label="$t('advanced.employment.employerProvince')"
            :outlined="true"
            :rules="rules.employerProvince"
            :readonly="disable"
            :value="form.employerProvince"
          ></TextFieldComponent>
        </div>
        <div class="form-group">
          <VueCountryIntl
            class="quasar-country-select glay-bg"
            :showAreaCode="false"
            v-model="form.employerCountryCode"
            disableCountry="Malaysia"
            type="country"
            @onchange="countrySelect"
            :placeholder="$t('common.selectCountry')"
            :disabled="disable"
          ></VueCountryIntl>
          <!-- <div class="color-error error-tip pt-5" style="font-size: 12px;">
            <span
              v-show="$v.form.employerCountryCode.$error && !$v.form.employerCountryCode.required"
            >{{$t('common.selectCountry')}}</span>
          </div>-->

          <div class="d-flex align-center error-msg mt-2 mb-2" style="min-height: 18px">
            <div v-if="!true">{{ this.$t('common.selectCountry') }}</div>
          </div>
        </div>
        <div class="form-group">
          <div class="upload-row row">
            <div class="file-opt-area" v-if="uploaderCanInit">
              <h5 class="upload-title" style="width: max-content;">{{ $t('advanced.employment.authImgUrl2') }}</h5>
              <UploadImg
                :type="'UPLOAD_EMPLOYMENT'"
                :previewImg="form.authImgUrl2Display"
                @uploadSuccess="_uploadSuccess1"
                @error="_error"
              ></UploadImg>
            </div>
          </div>

          <!-- <div class="error-tip color-error pt-30" style="font-size: 12px;">
            <span
              v-show="$v.form.authImgUrl2.$error && !$v.form.authImgUrl2.required"
            >{{$t('advanced.employment.authImgUrl2')}}</span>
          </div>-->

          <div class="d-flex align-center error-msg mt-2 mb-2" style="min-height: 18px">
            <div v-if="!true">{{ this.$t('advanced.address.authImgUrl2') }}</div>
          </div>
        </div>
        <!--<div class="btn-box">
        <q-btn
          class="no-shadow" color="primary"
          :loading="form.committing"
          :disabled="status == 0 || status == 1"
          @click="save"
          :label="$t('actions.save')"/>
        <q-btn
          class="no-shadow cancel-btn" color="standard"
          :loading="form.committing"
          :disabled="status == 0 || status == 1"
          @click="cancel"
          :label="$t('actions.cancel')"/>
        </div>-->
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import TextFieldComponent from '@/components/Form/TextField';
import SelectComponent from '@/components/Form/Select';

import { seniorCertificationApi } from '@/api/user/seniorCertification';
import tool from '@/common/js/tool';
import UploadImg from '@/components/UploadImg/UploadImg';
import FormEasy from './FormEasy';
import { getErrorLabelMixin } from '@/common/mixin/getErrorLabel.js';

const RULES_OTHER_SOURCE_INCOME = {
  required_if: {
    target: 'otherSourceIncome',
    values: [true]
  }
};

const RULES_IS_EMPLOYER = {
  required_if: {
    target: 'isEmployer',
    values: [true]
  }
};

const RULES_OTHER_INDUSTRY = {
  required_if: {
    target: 'otherIndustry',
    values: [true]
  }
};

export default {
  name: 'check-job',
  components: { UploadImg, FormEasy, TextFieldComponent, SelectComponent },
  mixins: [getErrorLabelMixin],
  data() {
    return {
      form: {
        employStatus: '', // 就业状态
        sourceIncome: '', // 就业状态对应的文字
        sourceIncomeName: '',
        industry: '', // 行业
        industryName: '', // 行业对应的名字
        jobTitle: '',
        companyName: '',
        employerBuilding: '',
        employerStreet: '',
        employerDistrict: '',
        employerCity: '',
        employerZipCode: '',
        employerProvince: '',
        employerCountryCode: '',
        authImgUrl2: '',
        authImgUrl2Display: '',
        committing: false,
        otherSourceIncome: false,
        otherIndustry: false,
        isEmployer: false
      },
      // 判断上传插件是否需要初始化，因为用户提交过资料后会立即跳转至详情页，因此这里需要做个判断
      uploaderCanInit: true,
      // 就业状态
      workStatus: [],
      // 行业
      industries: [],
      // 资金来源
      sourceIncome: [],
      disable: false,
      rules: {
        employStatus: {
          required: true
        },
        sourceIncome: {
          required: true
        },
        sourceIncomeName: RULES_OTHER_SOURCE_INCOME,
        industry: RULES_IS_EMPLOYER,
        industryName: RULES_OTHER_INDUSTRY,
        jobTitle: RULES_IS_EMPLOYER,
        companyName: RULES_IS_EMPLOYER,
        employerBuilding: RULES_IS_EMPLOYER,
        employerStreet: RULES_IS_EMPLOYER,
        employerZipCode: RULES_IS_EMPLOYER,
        employerCity: RULES_IS_EMPLOYER,
        employerDistrict: RULES_IS_EMPLOYER,
        employerProvince: RULES_IS_EMPLOYER,
        employerCountryCode: RULES_IS_EMPLOYER,
        authImgUrl2: {
          required: true
        }
      }
    };
  },
  props: {
    data /* employment */: {
      type: Object,
      required: true
    },
    status: {
      type: Number,
      required: true
    }
  },
  watch: {
    data: function(value) {
      this.form = value;
      if (this.form.industry == 20) {
        this.form.otherIndustry = true;
      }
      if (this.form.sourceIncome == 5) {
        this.form.otherSourceIncome = true;
      }
    },
    status: function(value) {
      this.disable = value == 0 || value == 1;
    }
  },
  mounted() {
    this.disable = this.status == 0 || this.status == 1;
    this.getIndustryData();
    this.getEmploymentStatusData();
    this.getCapitalSourceData();
  },
  destroyed() {},
  methods: {
    // 获取就业状况数据
    getEmploymentStatusData() {
      seniorCertificationApi.getEmploymentStatusData().then(res => {
        let data = res.data.map(item => {
          return {
            text: item.display,
            value: item.value
          };
        });

        this.workStatus = data;
      });
    },
    // 获取行业数据
    getIndustryData() {
      seniorCertificationApi.getIndustryData().then(res => {
        let data = res.data.map(item => {
          return {
            text: item.display,
            value: item.value
          };
        });

        this.industries = data;
      });
    },
    // 获取资金来源数据
    getCapitalSourceData() {
      seniorCertificationApi.getCapitalSourceData().then(res => {
        let data = res.data.map(item => {
          return {
            text: item.display,
            value: item.value
          };
        });

        this.sourceIncome = data;
      });
    },
    // 就业状况select事件
    _employmentStatusSelect(newVal) {
      let option = this.workStatus.filter(item => {
        return item.value === newVal;
      })[0];
      this.form.isEmployer = option.value == 1 /* employment */ || option.value == 4;
      this.form.employmentName = option.label;
    },
    // 行业select事件
    _industrySelect(newVal) {
      let option = this.industries.filter(item => {
        return item.value === newVal;
      })[0];

      if (option.value != 20 /* others */) {
        this.form.industryName = option.label;
        this.form.otherIndustry = false;
      } else {
        this.form.industryName = '';
        this.form.otherIndustry = true;
      }
    },
    // 资金来源select事件
    _sourceIncomeSelect(newVal) {
      let option = this.sourceIncome.filter(item => {
        return item.value === newVal;
      })[0];
      if (option.value != 5 /* others */) {
        this.form.sourceIncomeName = option.label;
        this.form.otherSourceIncome = false;
      } else {
        this.form.sourceIncomeName = '';
        this.form.otherSourceIncome = true;
      }
    },
    // 国籍select事件
    countrySelect(option) {
      this.form.countryName = option.name;
    },
    _uploadSuccess1(file, res) {
      this.form.authImgUrl2 = res.filename;
    },
    // 图片类型选择错误回调
    _error(errCode) {
      // Q_TYPE_DENIED: 上传文件类型不正确
      // F_EXCEED_SIZE: 上传的文件体积大于设定的体积
      if (errCode === 'F_EXCEED_SIZE') {
        this.$q.notify({
          color: 'negative',
          message: '上传的图片不能大于5M！',
          icon: 'warning',
          position: 'top',
          type: 'warning'
        });
      } else if (errCode === 'Q_TYPE_DENIED') {
        this.$q.notify({
          color: 'negative',
          message: '只能上传.jpg、.jpeg、.bmp、.png格式的图片',
          icon: 'warning',
          position: 'top',
          type: 'warning'
        });
      }
    },
    async save() {
      const validated = await this.$refs.validate.validate();
      if (!validated || this.committing) {
        return;
      }

      let data = this.form;
      data.employerCountryCode = data.employerCountryCode.toUpperCase();
      this.committing = true;

      return seniorCertificationApi
        .setAdvanceCertificationEmployment(data)
        .then(res => {
          this.successNotify(this.$t('advanced.employment.successSave'));
          this.committing = false;
          return true;
        })
        .catch(() => {
          this.committing = false;
          return false;
        });
    },
    cancel() {}
  }
};
</script>

<style lang="stylus" scoped>
@import '../CheckAddress/index.styl';

.notEmploy {
  margin-bottom: 30px;
}

.labelInexchangable {
  font-size: 13px;
}

.title1 {
  font-size: 16px;
  color: #333;
  height: 102px;
  line-height: 50px;


  .lineAdjust {
    line-height: 20px;
  }
}
</style>
